// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-element-group/kpi-element-group.less
// module id = 3763
// module chunks = 0